import { trpc } from '@web/lib/trpc';

import { BrandDetailsCard } from './brand-details-card';
import { toast } from 'sonner';
import { Brand } from '@shared/types';

type EditBrandDialogProps = {
  onClose?: () => void;
};

export function CreateBrandDialog({ onClose }: EditBrandDialogProps) {
  const { mutateAsync: createBrandMutation } = trpc.brand.create.useMutation();

  const { data: brands } = trpc.brand.listAll.useQuery();

  if (!brands) return null;

  const brand: Brand = {
    id: '',
    organizationId: '',
    name: '',

    state: '',
    city: '',
    address: '',
    zip: '',

    email: '',
    phone: '',
    website: '',

    isDefault: false,
  };

  return (
    <BrandDetailsCard
      newEntityCreation={true}
      defaultEditMode
      brand={brand}
      onSubmit={async (data) => {
        const result = await createBrandMutation(data)
          .then(() => 'SUCCESS' as const)
          .catch(() => {
            return 'FAILED' as const;
          });

        if (result === 'SUCCESS') {
          toast('Brand successfully created', {
            description: `you can now get in touch with ${data.name} !`,
          });

          onClose?.();
          return;
        }

        // if failed
        {
          toast.error('Failed to create Brand', {
            description: 'Please try again.',
          });
        }

        throw new Error('Failed to create Brand');
      }}
      onClose={() => {
        onClose?.();
      }}
    />
  );
}
